import React from 'react'
import { Download, FileSpreadsheet } from 'lucide-react'
import { FeatureGuard } from '../../../../../hooks/useFeatures'
import type { Annotation } from '../../../../ai-viewer/eventing/types'

interface DocumentActionsProps {
  annotations: Annotation[]
  currentAnnotationIndex: number
  isDrawing: boolean
  documentUrl: string | null
  fileName: string
  excelUrl?: string
  onToggleDrawing: () => void
  onNextAnnotation: () => void
  onPrevAnnotation: () => void
}

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  annotations,
  currentAnnotationIndex,
  isDrawing,
  documentUrl,
  fileName,
  excelUrl,
  onToggleDrawing,
  onNextAnnotation,
  onPrevAnnotation
}) => {
  const hasAnnotations = annotations.length > 0

  return (
    <div className="flex items-center gap-2">
      {/* Annotation Navigation - Hidden by default */}
      {false && hasAnnotations && (
        <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded">
          <button
            onClick={onPrevAnnotation}
            className="p-1 hover:bg-gray-200 rounded"
            title="Previous annotation"
            disabled={annotations.length <= 1}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <span className="text-xs text-gray-600 px-2">
            {currentAnnotationIndex + 1} / {annotations.length}
          </span>
          <button
            onClick={onNextAnnotation}
            className="p-1 hover:bg-gray-200 rounded"
            title="Next annotation"
            disabled={annotations.length <= 1}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      )}
      
      {/* Box Tool Button */}
      <FeatureGuard feature="boxTool">
        <button
          onClick={onToggleDrawing}
          className={`flex items-center gap-1 px-3 py-1 text-sm border rounded ${
            isDrawing 
              ? 'bg-orange-50 border-orange-400 text-orange-700' 
              : 'bg-white border-gray-300 hover:bg-orange-50 hover:border-orange-300'
          }`}
          title={isDrawing ? 'Leave Box Tool (B or Esc)' : 'Enter Box Tool (B)'}
        >
          {isDrawing ? 'Box Tool: On' : 'Box Tool'}
        </button>
      </FeatureGuard>
      
      {/* Export Button */}
      {documentUrl && excelUrl && (
        <a
          href={excelUrl}
          download={`${fileName.replace('.pdf', '')}.xlsx`}
          className="flex items-center gap-1 px-3 py-1 text-sm bg-green-600 hover:bg-green-700 text-white rounded font-medium shadow-sm transition-colors"
          title="Download Excel file with extracted data"
        >
          <FileSpreadsheet className="w-4 h-4" />
          Export
        </a>
      )}
    </div>
  )
}

